import React, {useState} from 'react';
import styles from './BuildingLoadingPlacesView.module.styl';
import {Heading} from 'uikit/components';
import {arrayOf, bool, number, shape, string} from 'prop-types';
import BuildingLoadingPlaceCard from 'components/loading/BuildingLoadingPlaceCard/BuildingLoadingPlaceCard';

export default function BuildingLoadingPlacesView({placesData, startDate, endDate, showCameraDetectionData}) {

    const [activeCalendar, setActiveCalendar] = useState(null);

    function showCalendar(index) {
        setActiveCalendar(index);
    }

    return (
        <>
            <Heading size={'h2'} className={styles.heading} name="building-loading-places-header">Места, входящие в состав объекта</Heading>
            {placesData.map((item, index) =>
                <BuildingLoadingPlaceCard
                    key={index}
                    endDate={endDate}
                    index={index+1}
                    startDate={startDate}
                    placeData={item}
                    onClick={showCalendar}
                    showToggle={activeCalendar === index}
                    showCameraDetectionData={showCameraDetectionData}
                    />)}
        </>
    )
}

BuildingLoadingPlacesView.propTypes = {
    placesData: arrayOf(
        shape({
            id: number.isRequired,
            name: string.isRequired,
            standardThroughput: number.isRequired,
            workingDays: arrayOf(shape({
                day: string,
                startTime: string,
                endTime: string,
                date: string,
            })).isRequired,
            loadingPercent: number
        }),
    ),
    startDate: string.isRequired,
    endDate: string.isRequired,
    showCameraDetectionData: bool.isRequired,
}
